export var NewUserQuestType;
(function (NewUserQuestType) {
    NewUserQuestType["OnChain"] = "onchain";
    NewUserQuestType["Pro"] = "pro";
    NewUserQuestType["SignupReward"] = "signupReward";
})(NewUserQuestType || (NewUserQuestType = {}));
export var QuestRewardType;
(function (QuestRewardType) {
    QuestRewardType["Referral"] = "referral";
    QuestRewardType["Offer"] = "offer";
    QuestRewardType["OnChain"] = "onchain";
})(QuestRewardType || (QuestRewardType = {}));
